import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesGetThumbnails extends BaseAction {
    constructor(dataKey) {
        const id = '5579da1c-af2b-445e-9a5c-71bda6d8e9d9'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getThumbnails(params) {
        this.params = Object.assign({
            fields: 'id,thumbnail',
            pc: 8
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-get-thumbnails.js